import React from 'react';
import { NODE_DEFS, ACCENT_COLORS } from '../../data/nodeDefinitions';
import Icon from '../ui/Icon';
import styles from './CanvasNode.module.css';

function nodeBodyText(type, cfg) {
  if (!cfg) return '';
  switch (type) {
    case 'entry-event':     return cfg.event || '—';
    case 'entry-schedule':  return cfg.preset || cfg.cron || 'Custom cron';
    case 'entry-segment':   return cfg.segmentId || '—';
    case 'entry-api':       return cfg.description || 'API Trigger';
    case 'action-push':     return cfg.title || 'No title set';
    case 'action-inapp':    return cfg.title || 'No title set';
    case 'action-whatsapp': return cfg.template || 'No template';
    case 'action-email':    return cfg.subject || 'No subject';
    case 'action-sms':      return cfg.message ? cfg.message.slice(0, 30) + '…' : 'No message';
    case 'action-webhook':  return cfg.url || 'No URL';
    case 'wait-relative':   return 'Wait ' + (cfg.amount || '1') + ' ' + (cfg.unit || 'hours');
    case 'wait-absolute':   return cfg.rule === 'next_day_noon' ? 'Tomorrow 12 PM' : (cfg.rule || '—');
    case 'logic-condition': return cfg.event || '—';
    case 'logic-ab':        return (cfg.splitA || '50') + '% / ' + (cfg.splitB || '50') + '%';
    case 'logic-goal':      return cfg.event || '—';
    case 'logic-exit':      return 'End of journey';
    default:                return '';
  }
}

class CanvasNode extends React.Component {
  constructor(props) {
    super(props);
    this.ref      = React.createRef();
    this._drag    = null;
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp   = this.onMouseUp.bind(this);
  }

  onMouseDown(e) {
    if (e.button !== 0) return;
    e.stopPropagation();
    const { node } = this.props;
    this._drag = { startX: e.clientX - node.x, startY: e.clientY - node.y };
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup',   this.onMouseUp);
  }

  onMouseMove(e) {
    if (!this._drag) return;
    const { onMove, node } = this.props;
    onMove && onMove(node.id, e.clientX - this._drag.startX, e.clientY - this._drag.startY);
  }

  onMouseUp() {
    this._drag = null;
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup',   this.onMouseUp);
  }

  componentWillUnmount() {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup',   this.onMouseUp);
  }

  render() {
    const { node, selected, onSelect, onDelete } = this.props;
    const def = NODE_DEFS[node.type] || {};
    const accentColor = ACCENT_COLORS[def.accentType] || '#888';
    const body = nodeBodyText(node.type, node.cfg);

    return (
      <div
        ref={this.ref}
        className={[styles.node, selected ? styles.selected : ''].join(' ')}
        style={{
          left: node.x,
          top:  node.y,
          '--accent': accentColor,
        }}
        onMouseDown={this.onMouseDown}
        onClick={e => { e.stopPropagation(); onSelect && onSelect(node.id); }}
      >
        <div className={styles.header} style={{ borderBottom: '1px solid ' + accentColor + '30' }}>
          <div className={styles.ico} style={{ background: def.icoC, color: def.icoT }}>
            <Icon name={def.ico} size={16} />
          </div>
          <div className={styles.label}>{def.label}</div>
          <button
            className={styles.del}
            onClick={e => { e.stopPropagation(); onDelete && onDelete(node.id); }}
          ><span className="material-symbols-rounded" style={{ fontSize: 13 }}>close</span></button>
        </div>

        {body && (
          <div className={styles.body}>
            <div className={styles.bodyText}>{body}</div>
          </div>
        )}

        {def.hasBranches && def.branches && (
          <div className={styles.branches}>
            {def.branches.map((b, i) => (
              <div key={i} className={[styles.branch, styles['branch-' + def.branchStyles[i]]].join(' ')}>
                {b}
              </div>
            ))}
          </div>
        )}

        {/* Connection ports */}
        <div className={styles.portTop} data-port="top" data-node={node.id} />
        <div className={styles.portBot} data-port="bottom" data-node={node.id} />
      </div>
    );
  }
}

export default CanvasNode;
